import { disposeSimulator } from '../OCPP/simulator-session'
import defaultSettings, { SETTINGS_VERSION } from '../Config/default-settings'

// Keys older versions listed that the charge point now derives itself.
const RETIRED_KEYS = ['NumberOfConnectors', 'SupportedFileTransferProtocols']

// Saved settings sit on top of the defaults, so settings saved by an older version still get
// new fields and configuration keys, and an empty OCPP server url falls back to the default one.
// Settings saved before SETTINGS_VERSION 2 carried wrong station defaults (e.g. no
// FirmwareManagement profile, measurands that do not exist) and a fake upload simulation: those
// parts are reset, keeping only keys the user added and the unlock results.
export const loadSettings = () => {
  let saved = null
  try {
    saved = JSON.parse(localStorage.getItem('OCPPSettings'))
  } catch (error) {
    saved = null
  }
  if (!saved || typeof saved !== 'object') return defaultSettings

  const mainSettings = { ...defaultSettings.mainSettings, ...saved.mainSettings }
  if (!mainSettings.centralSystemUrl?.trim()) mainSettings.centralSystemUrl = defaultSettings.mainSettings.centralSystemUrl
  mainSettings.numberOfConnectors = Number(mainSettings.numberOfConnectors) || defaultSettings.mainSettings.numberOfConnectors

  const current = saved.settingsVersion === SETTINGS_VERSION
  const savedKeys = Array.isArray(saved.stationSettings) ? saved.stationSettings : []
  const defaultKeys = defaultSettings.stationSettings
  const stationSettings = current
    ? [...savedKeys, ...defaultKeys.filter(key => !savedKeys.some(x => x.key === key.key))]
    : [...defaultKeys, ...savedKeys.filter(key => !defaultKeys.some(x => x.key === key.key) && !RETIRED_KEYS.includes(key.key))]

  const simulation = current
    ? { ...defaultSettings.simulation, ...saved.simulation }
    : {
        ...defaultSettings.simulation,
        connectorOneUnlock: saved.simulation?.connectorOneUnlock ?? defaultSettings.simulation.connectorOneUnlock,
        connectorTwoUnlock: saved.simulation?.connectorTwoUnlock ?? defaultSettings.simulation.connectorTwoUnlock,
      }

  return {
    ...defaultSettings,
    ...saved,
    settingsVersion: SETTINGS_VERSION,
    mainSettings,
    bootNotification: { ...defaultSettings.bootNotification, ...saved.bootNotification },
    stationSettings,
    simulation,
  }
}

export const saveSettings = (settings) => {
  localStorage.setItem('OCPPSettings', JSON.stringify(settings))
  // New settings (URL, id, version, connectors, ...) need a fresh charge point.
  disposeSimulator()

  if (typeof window !== 'undefined') {
    window.dispatchEvent(new Event('ocpp-settings-saved'))
  }
}
